import { createBrowserHistory } from "history";

const history = createBrowserHistory();
export function refreshCurrentPage() {
  history.push("/temp");
  history.goBack();
}
export default history;
